import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { lpForm } from 'lp-form'
import { Input, SubmitButton } from 'lp-components'
import {
  Field,
  FormSection,
  formValueSelector,
  propTypes as formPropTypes,
} from 'redux-form'
import { PostsFilterToolbar } from '../components'
import { isEmpty } from 'lodash'

// WCAG 2.5.3: accessible name must contain the visible placeholder text; keep in sync.
const POSTS_SEARCH_QUERY_PLACEHOLDER =
  'Search discussions by title, description, or comment'

const propTypes = {
  ...formPropTypes,
  filterOptions: Types.postsFilterOptions.isRequired,
  selectedFilters: PropTypes.object,
  filterFieldsComponent: PropTypes.elementType,
  filterToolbarVariant: PropTypes.string,
}

const defaultProps = {
  selectedFilters: {},
  filterFieldsComponent: undefined,
  filterToolbarVariant: 'default',
}

const FORM_NAME = 'educator-posts-search'

function PostsSearchForm({
  change,
  handleSubmit,
  initialValues,
  filterOptions,
  selectedFilters,
  submitting,
  filterFieldsComponent,
  filterToolbarVariant,
}) {
  return (
    <form onSubmit={handleSubmit} noValidate role="search">
      <div className="search-form">
        <div className="search-bar">
          <Field
            name="query"
            component={Input}
            label={false}
            aria-label={POSTS_SEARCH_QUERY_PLACEHOLDER}
            placeholder={POSTS_SEARCH_QUERY_PLACEHOLDER}
          />
          <SubmitButton
            {...{ submitting }}
            style="alert"
            data-cy="search-button"
          >
            Search
          </SubmitButton>
        </div>
      </div>
      {!isEmpty(filterOptions) && (
        <FormSection name="filters">
          <PostsFilterToolbar
            filterOptions={filterOptions}
            applyFilter={handleSubmit}
            resetFilter={(filterName) => {
              change(`filters.${filterName}`, '')
              setTimeout(handleSubmit, 0)
            }}
            selectedFilters={selectedFilters}
            appliedFilters={initialValues.filters}
            filterFieldsComponent={filterFieldsComponent}
            filterToolbarVariant={filterToolbarVariant}
          />
        </FormSection>
      )}
    </form>
  )
}

PostsSearchForm.propTypes = propTypes
PostsSearchForm.defaultProps = defaultProps

const formSelector = formValueSelector(FORM_NAME)

function mapStateToProps(state) {
  return {
    selectedFilters: formSelector(state, 'filters'),
  }
}

const mapDispatchToProps = {}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lpForm({ name: FORM_NAME })
)(PostsSearchForm)
